import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { Paging, RequestOption } from 'src/app/shared/model/common.model';
import { UserSupplierService } from 'src/app/shared/service/user-supplier.service';
import { USERTYPE } from '../../../../../../core/enums/routing-item.enum';
import { ConfirmationDialogComponent } from '../../../../../../shared/components/dialog/confirmation-dialog.component';
import { PATH_ROUTING } from '../../../../../../shared/enums/routing-enums';
import { ExcelService } from './../../../../../../shared/service/excel.service';
import { SrmService } from 'src/app/shared/service/srm.service';
import { SupplierFormFilter } from 'src/app/shared/model/eol-setups.model';
import moment from 'moment';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
@Component({
  selector: 'eol-setups-supplier',
  templateUrl: './eol-setups-supplier.component.html',
  styleUrls: ['./eol-setups-supplier.component.scss']
})
export class EolSetupsSupplierComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ["checkbox", "supplierGsl", "supplierName", "parentSupplier", "scxId", "srm", "destruction", "recycling", "createdBy", "creationDate", "lastUpdatedBy", "lastUpdatedDate", "recordId", "attribute1", "attribute2", "attribute3", "attribute4", "attribute5", "action"];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  requestOption: RequestOption | any = new RequestOption();
  type = 'external_supplier';
  isInternal = false;
  search = '';
  status = '';
  supplierGsl = '';
  parentName = '';
  createdDateRange: Date[] | null = null;
  sortTimeoutInstance: any;
  isCreatingNewRow = false;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private spinner: Spinner,
    private toastr: ToastrService,
    private router: Router,
    private userSupplierService: UserSupplierService,
    private srmService: SrmService,
    private dialog: MatDialog,
    private activatedRouter: ActivatedRoute,
    private excelService: ExcelService
  ) {
    this.activatedRouter.data.subscribe(res => {
      if (res.type === USERTYPE.INTERNAL_USER) {
        this.type = USERTYPE.INTERNAL_USER;
        this.isInternal = true;
        this.displayedColumns = ["checkbox", "supplierGsl", "supplierName", "parentSupplier", "scxId", "srm", "destruction", "recycling", "createdBy", "creationDate", "lastUpdatedBy", "lastUpdatedDate", "recordId", "attribute1", "attribute2", "attribute3", "attribute4", "attribute5", "action"];
      }
    });
  }

  ngOnInit() {
    this.loadDataTable(true);
  }

  ngAfterViewInit() {
  }

  addNewSupplier() {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_EOL_SETUPS_SUPPLIER_FORM]);
  }

  public getListUserSupplier() {
    this.spinner.show();
    this.srmService.getSupplierDataTable(this.requestOption).subscribe(res => {
      this.spinner.hide();
      if (res.data.content) {
        this.isCreatingNewRow = false;
        this.dataSource.data = res.data.content.map((item: any) => this.normalizeRow(item));
        const rq: RequestOption | any = { ...this.requestOption };
        rq.pagingOptions.totalPages = res.data.totalPages;
        rq.pagingOptions.numberOfElements = res.data.numberOfElements;
        rq.pagingOptions.totalElements = res.data.totalElements;
        this.requestOption = rq;
      }
    });
  }

  public onChangeRequestOption(event: RequestOption) {
    this.requestOption = event;
    this.getListUserSupplier();
  }

  public initialRequestOption() {
    this.requestOption.pagingOptions.totalPages = 0;
    this.requestOption.pagingOptions.numberOfElements = 0;
  }

  public loadDataTable(goToFirstPage?: boolean) {
    if (goToFirstPage) {
      this.requestOption.pagingOptions = new Paging(this.requestOption.pagingOptions.size);
      this.requestOption.pagingOptions!.sort.sortBy = 'id';
      this.requestOption.pagingOptions!.sort.sortOrder = 'DESC';
      this.initialRequestOption();
    }
    this.getListUserSupplier();
  }

  public edit(id: number | string) {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_EOL_SETUPS_SUPPLIER_FORM, id]);
  }

  public deleteUser(id: number | string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_DELETE_RECORD
      }
    });
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.spinner.show();
        this.srmService.deleteSupplierForm(id).subscribe((res: any) => {
          this.spinner.hide();
          if (res.status === 200) {
            this.toastr.success(MESSAGE_TOAST.DELETE_RECORD_SUCCESS);
            this.getListUserSupplier();
          }
        }, err => this.spinner.hide());
      }
    });
  }

  // public changeActive(suppilerId, event) {
  //   const model = {
  //     id: suppilerId,
  //     active: event.checked
  //   };
  //   const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
  //     data: {
  //       message: !model.active ? MESSAGE_TOAST.CONFIRM_CHANGE_DEACTIVE : MESSAGE_TOAST.CONFIRM_CHANGE_ACTIVE
  //     }
  //   });

  //   dialogRef.afterClosed().subscribe(confirmed => {
  //     if (confirmed) {
  //       this.spinner.show();
  //       this.userSupplierService.changeActiveByType(this.type, model).subscribe(res => {
  //         this.spinner.hide();
  //         if (res.status === 200) {
  //           if (model.active) {
  //             this.toastr.success(MESSAGE_TOAST.ACTIVATED_SUPPLIER);
  //           } else {
  //             this.toastr.success(MESSAGE_TOAST.DEACTIVATED_SUPPLIER);
  //           }
  //           this.getListUserSupplier();
  //         }
  //       });
  //     } else {
  //       this.loadDataTable(false);
  //     }
  //   });
  // }

  public searchData() {
    this.search = this.search.trim();
    this.requestOption.pagingOptions.number = 0;
    const createdDateRange = {
    createdDateFrom:
       this.createdDateRange && this.createdDateRange[0]
          ? moment(this.createdDateRange[0]).startOf('day').toISOString()
          : undefined,
      createdDateTo:
       this.createdDateRange && this.createdDateRange[1]
          ? moment(this.createdDateRange[1]).endOf('day').toISOString()
          : undefined,
    }
    this.spinner.show();
    this.srmService.getSupplierDataTable(this.requestOption, this.search, this.supplierGsl, createdDateRange).subscribe((res: any) => {
      this.spinner.hide();
      if (res.status === 200) {
          this.isCreatingNewRow = false;
          this.dataSource.data = res.data.content.map((item: any) => this.normalizeRow(item));
          const rq: RequestOption | any = { ...this.requestOption };
          rq.pagingOptions.totalPages = res.data.totalPages;
          rq.pagingOptions.numberOfElements = res.data.numberOfElements;
          rq.pagingOptions.totalElements = res.data.totalElements;
          this.requestOption = rq;
        }
      });
  }

  public sortData(sort: Sort) {
    if (this.sortTimeoutInstance) {
      clearTimeout(this.sortTimeoutInstance);
    }
    this.sortTimeoutInstance = setTimeout(() => {
      this.requestOption.pagingOptions.sort.sortBy = sort.active;
      this.requestOption.pagingOptions.sort.sortOrder = sort.direction;
      this.getListUserSupplier();
    }, 500);
  }

  public isAllRowsSelected() {
    return this.dataSource.data.length > 0 && this.dataSource.data.every(item => item.isChecked);
  }

  public isSomeRowsSelected() {
    return this.dataSource.data.some(item => item.isChecked) && !this.isAllRowsSelected();
  }

  public toggleAllRows(checked: boolean) {
    this.dataSource.data = this.dataSource.data.map(item => {
      item.isChecked = checked;
      return item;
    });
  }

  public toggleRow(row: any) {
    row.isChecked = !row.isChecked;
    this.dataSource.data = [...this.dataSource.data];
  }

  // public createNew() {
  //   this.isCreatingNewRow = true;
  //   const newRow = {
  //     isChecked: false,
  //     isNew: true,
  //     isEditing: false,
  //     supplierGsl: '',
  //     supplierName: '',
  //     parentSupplier: '',
  //     scxId: '',
  //     srm: '',
  //     destruction: '',
  //     recycling: '',
  //     createdBy: '',
  //     creationDate: '',
  //     lastUpdatedBy: '',
  //     lastUpdatedDate: '',
  //     recordId: '',
  //     attribute1: '',
  //     attribute2: '',
  //     attribute3: '',
  //     attribute4: '',
  //     attribute5: ''
  //   };

  //   this.dataSource.data = [newRow, ...this.dataSource.data];
  // }

  public canUpdate() {
    // use in export, check before delete
    return this.getSelectedRows().length > 0;
  }

  public canDelete() {
    return this.getSelectedRows().length > 0;
  }

  public update() {
    if (!this.canUpdate()) {
      return;
    }

    this.dataSource.data = this.dataSource.data.map(row => {
      row.isEditing = row.isChecked;
      return row;
    });
    this.isCreatingNewRow = this.dataSource.data.some(row => row.isNew);
    this.dataSource.data = [...this.dataSource.data];
  }

  public delete() {
    if (!this.canDelete()) {
      return;
    }

    const selectedCount = this.getSelectedRows().length;
    this.dataSource.data = this.dataSource.data.filter(row => !row.isChecked);
    this.isCreatingNewRow = this.dataSource.data.some(row => row.isNew);
    this.toastr.success(`Deleted ${selectedCount} selected record(s) in local mode`);
  }

  public export() {
    const selectedIds = this.getSelectedRows().map(row => row.id);
    // const filterExport: SupplierFormFilter = {
    //   searchKey: (this.search|| '').trim(),
    //   supplierGsl: (this.supplierGsl|| '').trim(),
    //   createdDateFrom:
    //    this.createdDateRange && this.createdDateRange[0]
    //       ? moment(this.createdDateRange[0]).startOf('day').toISOString()
    //       : undefined,
    //   createdDateTo:
    //    this.createdDateRange && this.createdDateRange[1]
    //       ? moment(this.createdDateRange[1]).endOf('day').toISOString()
    //       : undefined,
      // sortBy: this.requestOption?.pagingOptions?.sort?.sortBy,
      // sortDirection: this.requestOption?.pagingOptions?.sort?.sortBy ? 
      //   this.requestOption?.pagingOptions?.sort?.sortOrder?.toUpperCase() : '',
      // page: this.requestOption?.pagingOptions?.number,
      // size: this.requestOption?.pagingOptions?.size,
      // ids: selectedIds?.length > 0 ? selectedIds : undefined,
    // }
    this.spinner.show();
    this.srmService.exportSupplierForm(selectedIds).subscribe(res => {
      this.spinner.hide();
      this.excelService.saveAsExcelFile(res, 'EOL_Setups_Supplier_Export.xlsx');
    }, () => {
      this.spinner.hide();
    });
  }

  public saveNewRow(row: any) {
    // const supplierName = this.toVarchar250(row.supplierName);
    // if (!supplierName) {
    //   this.toastr.error('Supplier Name is required');
    //   return;
    // }

    row.supplierName = this.toVarchar250(row.supplierName);
    row.supplierGsl = this.toVarchar250(row.supplierGsl);
    row.parentSupplier = this.toVarchar250(row.parentSupplier);
    row.scxId = this.toVarchar250(row.scxId);
    row.srm = this.toVarchar250(row.srm);
    row.destruction = this.toVarchar250(row.destruction);
    row.recycling = this.toVarchar250(row.recycling);
    row.createdBy = this.toVarchar250(row.createdBy);
    row.lastUpdatedBy = this.toVarchar250(row.lastUpdatedBy);
    row.attribute1 = this.toVarchar250(row.attribute1);
    row.attribute2 = this.toVarchar250(row.attribute2);
    row.attribute3 = this.toVarchar250(row.attribute3);
    row.attribute4 = this.toVarchar250(row.attribute4);
    row.attribute5 = this.toVarchar250(row.attribute5);
    row.recordId = row.recordId !== '' && row.recordId !== null && row.recordId !== undefined
      ? Number(row.recordId)
      : null;
    row.creationDate = row.creationDate ? new Date(row.creationDate).toLocaleString() : '';
    row.lastUpdatedDate = row.lastUpdatedDate ? new Date(row.lastUpdatedDate).toLocaleString() : '';
    row.isNew = false;
    row.isEditing = false;
    row.isChecked = false;
    this.isCreatingNewRow = this.dataSource.data.some(item => item.isNew);
    this.dataSource.data = [...this.dataSource.data];
    this.toastr.success('Saved in local mode (API disabled for testing)');
  }

  private toVarchar250(value: any) {
    return (value || '').toString().trim().slice(0, 250);
  }

  public convertYesNo(value: any): string {
    if (value === true || value === 'true') {
      return 'Yes';
    }

    if (value === false || value === 'false') {
      return 'No';
    }

    return '';
  }

  private normalizeRow(item: any) {
    return {
      ...item,
      isChecked: false,
      isNew: false,
      isEditing: false,
      supplierGsl: item.supplierGsl || '',
      supplierName: item.supplierName || '',
      parentSupplier: item.parentSupplier || '',
      scxId: item.scxId || '',
      srm: item.srm === null || item.srm === undefined ? null : item.srm,
      destruction: item.destruction === null || item.destruction === undefined ? null : item.destruction,
      recycling: item.recycling === null || item.recycling === undefined ? null : item.recycling,
      createdBy: item.createdBy || '',
      createdDate: item.createdDate ? new Date(item.createdDate).toLocaleString() : '',
      updatedBy: item.updatedBy || '',
      updatedDate: item.updatedDate  ? new Date(item.updatedDate).toLocaleString() : '',
      recordId: item.recordId || '',
      attribute1: item.attribute1 || '',
      attribute2: item.attribute2 || '',
      attribute3: item.attribute3 || '',
      attribute4: item.attribute4 || '',
      attribute5: item.attribute5 || ''
    };
  }

  private getSelectedRows() {
    return this.dataSource.data.filter(row => row.isChecked);
  }
}